import { talukaListApi } from "../../api/taluka/talukaListApi"
import { Taluka } from "../../entities/taluka"

type PayloadShape = Parameters<typeof talukaListApi>[0]

export async function talukaListService(payload: PayloadShape, token?: null | string) {
	const taluka = await talukaListApi(payload, token)
	return taluka as NonNullable<Taluka[]>
}
